import React, { useState } from 'react';
import { trackContactFormSubmission, trackFormSubmission } from '../utils/analytics';

const FormField = ({ label, name, type = 'text', value, onChange, required = false, rows }) => {
  const inputProps = {
    type,
    name,
    id: name,
    value,
    onChange,
    required,
    className: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-gadventures-purple focus:ring-gadventures-purple-light"
  };

  return (
    <div>
      <label htmlFor={name} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      {type === 'textarea' ? (
        <textarea {...inputProps} rows={rows} />
      ) : (
        <input {...inputProps} />
      )}
    </div>
  );
};

function GetStarted() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    destination: '',
    message: '',
    subscribe: true  // Default to true for marketing opt-in
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('https://gadventures.revolutiontravel.ca:5656/api/getStarted/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Failed to submit form');
      }

      // Clear form after successful submission
      setFormData({
        name: '',
        email: '',
        phone: '',
        destination: '',
        message: '',
        subscribe: true
      });

      // Track successful form submission
      trackContactFormSubmission(formData);
      trackFormSubmission('contact_form', 'lead_form', true);

      // Show success message
      alert('Thank you for your inquiry! We will contact you soon.');

      // Analytics tracking
      const trackingEvents = [
        () => window.trackLeadSubmission('get_started_form'),
        () => window.trackFunnelEvent('form_submission', { 'form_type': 'get_started' }),
        () => window.gtag?.('event', 'form_submitted', {
          'event_category': 'Engagement',
          'event_label': 'Contact Form'
        }),
        () => window.fbq?.('track', 'Lead')
      ];

      trackingEvents.forEach(track => {
        try {
          track();
        } catch (error) {
          console.error('Tracking error:', error);
        }
      });
    } catch (error) {
      console.error('Form submission error:', error);
      // Track failed submission
      trackFormSubmission('contact_form', 'lead_form', false);
      alert('Sorry, there was an error submitting your form. Please try again.');
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    window.trackFunnelEvent('form_field_interaction', {
      'field_name': name
    });
  };

  const formFields = [
    { label: 'Full Name', name: 'name', required: true },
    { label: 'Email', name: 'email', type: 'email', required: true },
    { label: 'Phone Number', name: 'phone', type: 'tel' },
    { label: 'Preferred Destination', name: 'destination' },
    { label: 'Your Message', name: 'message', type: 'textarea', rows: 4 }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-8">
            Get Started: Contact Us About Your Adventure
          </h2>
          <p className="text-xl text-gray-600">
            Ready to embark on the journey of a lifetime? Fill out the form below and one of our travel experts will contact you to discuss how G Adventures can help you discover authentic experiences around the world. We'll help you explore our wide range of small group tours, find the perfect destination, and customize your adventure to match your interests and travel style.
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg shadow-xl p-8 max-w-2xl mx-auto border border-gray-200">
          <form onSubmit={handleSubmit} className="space-y-8">
            {formFields.map(field => (
              <FormField
                key={field.name}
                {...field}
                value={formData[field.name]} 
                onChange={handleInputChange}
                className="mb-6 bg-white border-2 border-gray-300 rounded-lg p-3 focus-within:border-gadventures-purple focus-within:ring-2 focus-within:ring-gadventures-purple-light transition duration-200"
              />
            ))}

            <div className="flex items-start">
              <div className="flex items-center h-5">
                <input
                  id="subscribe"
                  name="subscribe"
                  type="checkbox"
                  checked={formData.subscribe}
                  onChange={handleInputChange}
                  className="h-4 w-4 text-gadventures-purple border-gray-300 rounded focus:ring-gadventures-purple-light"
                />
              </div>
              <div className="ml-3">
                <label htmlFor="subscribe" className="text-sm text-gray-700">
                  Yes! I want to receive travel inspiration, deals, and updates about G Adventures
                </label>
              </div>
            </div>

            <div className="mt-8">
              <button
                type="submit"
                className="w-full flex justify-center py-4 px-6 border border-transparent rounded-lg shadow-md text-base font-semibold text-white bg-gadventures-purple hover:bg-gadventures-purple-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gadventures-purple-light transition duration-200"
              >
                Send Message
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default GetStarted;
